

import { useContext, useEffect, useState } from 'react'


import 'bootstrap-daterangepicker/daterangepicker.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from '../../components/hooks/useForm';
import Message from '../../components/ui/Message';
import { TariffsContext } from '../../context/tariff/TariffContext';
import { useRequiredFields } from '../../hooks/useRequiredFields';




export const TariffPage = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [isUpdate, setIsUpdate] = useState(false);
    const { addTariff, updateTariff, paymentTypes, brands, banks, currencies, channels } = useContext(TariffsContext);
    const [errorMessage, setErrorMessage] = useState('');
    const required = useRequiredFields();
    const [successMessage, setSuccessMessage] = useState('');

    var tariff;
    var merchant = state.merchant;

    if (state && state.tariff != undefined) {


        tariff = state.tariff;

    } else {
        tariff = {
            paymentTypeId: '',
            brandId: -1,
            bankId: -1,
            currencyId: 188,
            channelId: -1,
            description: '',
            commission: '',
            advanceRent: '',
            service: '',
            commission_int: '',
        }
    }

    useEffect(() => {
        if (state && state.tariff != undefined) {
            setIsUpdate(true);
        }
    }, []);


    const { formState, onInputChange } = useForm(tariff);

    const {
        paymentTypeId,
        brandId,
        bankId,
        currencyId,
        channelId,
        description,
        commission,
        advanceRent,
        service,
        commission_int } = formState

    /*useEffect(() => {
        const formValid = paymentTypeId.length > 0 && brandId > 0 && bankId > 0 && currencyId > 0 && channelId > 0 && description.length > 0

        setIsFormValid(formValid);
    }, [paymentTypeId, brandId, bankId, currencyId, channelId,
        description, commission, advanceRent, service, commission_int])*/



    const handleSave = async () => {

        const formValid = paymentTypeId.length > 0 && brandId > 0 && bankId > 0 && currencyId > 0 && channelId > 0 && description.length > 0
            && commission.toString().length > 0 && advanceRent.toString().length > 0 && service.toString().length > 0;
        if (!formValid) {
            required.fail();
            setErrorMessage("Debe completar los campos requeridos");
            return false;
        }

        var resp = "";
        formState.merchantId = merchant.id;
        formState.commission_int = 0;
        if (isUpdate) {
            resp = await updateTariff(formState);
        } else {
            resp = await addTariff(formState);
        }
        if (resp == "success") {
            setSuccessMessage(isUpdate ? "Tarifa actualizada correctamente" : "Tarifa creada correctamente.");
        } else {
            setErrorMessage(resp);
        }
    }

    const removeError = () => {
        setErrorMessage('');
    }

    const removeSucessMessage = () => {
        setSuccessMessage('');
        navigate(-1);
    }

    return (

        <div className='container d-flex align-items-center justify-content-center mt-5' style={styles.container}>


            <div className='col-md-6'>
                <h3>{isUpdate ? 'Actualizar tarifa' : 'Crear tarifa'}</h3>
                <hr />

                <form className="row g-3 " >


                    <div className="mb-3">
                        <label htmlFor="paymentTypeSelect" className="form-label">Tipo de pago *</label>
                        <select id='paymentTypeSelect' className={`form-select${required.mark(!paymentTypeId)}`} name='paymentTypeId' value={paymentTypeId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {paymentTypes.length > 0
                                ?
                                paymentTypes.map(paymentType => (
                                    <option key={paymentType.code} value={paymentType.code} selected={paymentType.code == paymentTypeId}>{paymentType.description}</option>
                                ))
                                :
                                <option selected>No hay tipos de pago disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="brandSelect" className="form-label">Marca *</label>
                        <select id='brandSelect' className={`form-select${required.mark(!(brandId > 0))}`} name='brandId' value={brandId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {brands.length > 0
                                ?
                                brands.map(brand => (
                                    <option key={brand.code} value={brand.code} selected={brand.code == brandId}>{brand.description}</option>
                                ))
                                :
                                <option selected>No hay marcas disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="bankSelect" className="form-label">Banco *</label>
                        <select id='bankSelect' className={`form-select${required.mark(!(bankId > 0))}`} name='bankId' value={bankId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {banks.length > 0
                                ?
                                banks.map(bank => (
                                    <option key={bank.code} value={bank.code} selected={bank.code == bankId}>{bank.description}</option>
                                ))
                                :
                                <option selected>No hay bancos disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="currencySelect" className="form-label">Moneda *</label>
                        <select id='currencySelect' className={`form-select${required.mark(!(currencyId > 0))}`} name='currencyId' value={currencyId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {currencies.length > 0
                                ?
                                currencies.map(currency => (
                                    <option key={currency.code} value={currency.code} selected={currency.code == currencyId}>{currency.description}</option>
                                ))
                                :
                                <option selected>No hay monedas disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>



                    <div className="mb-3">
                        <label htmlFor="channelSelect" className="form-label">Canal *</label>
                        <select id='channelSelect' className={`form-select${required.mark(!(channelId > 0))}`} name='channelId' value={channelId} onChange={onInputChange}  >
                            <option key={0} value={-1} >Seleccione una opción</option>
                            {channels.length > 0
                                ?
                                channels.map(channel => (
                                    <option key={channel.code} value={channel.code} selected={channel.code == channelId}>{channel.description}</option>
                                ))
                                :
                                <option selected>No hay canales disponibles</option>
                            }
                        </select>
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="tariffDescInput" className="form-label">Descripción *</label>
                        <input
                            id='tariffDescInput'
                            type="text"
                            className={`form-control${required.mark(!description)}`}
                            placeholder="Descripción"
                            name="description"
                            value={description}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="commisionInput" className="form-label">Comisión *</label>
                        <input
                            id='commisionInput'
                            type="text"
                            className={`form-control${required.mark(commission.toString().length === 0)}`}
                            placeholder="Comisión"
                            name="commission"
                            value={commission}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="advanceRentInput" className="form-label">Adelanto de renta *</label>
                        <input
                            id='advanceRentInput'
                            type="text"
                            className={`form-control${required.mark(advanceRent.toString().length === 0)}`}
                            placeholder="Adelanto de renta"
                            name="advanceRent"
                            value={advanceRent}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="serviceInput" className="form-label">Servicio *</label>
                        <input
                            id='serviceInput'
                            type="text"
                            className={`form-control${required.mark(service.toString().length === 0)}`}
                            placeholder="Servicio"
                            name="service"
                            value={service}
                            onChange={onInputChange}
                            required
                        />
                        <div className="invalid-feedback">Campo requerido</div>
                    </div>

                    {/* <div className="mb-3">
                        <label htmlFor="commissionIntInput" className="form-label">Comisión internacional *</label>
                        <input
                            id='commissionIntInput'
                            type="text"
                            className="form-control"
                            placeholder="Comisión internacional"
                            name="commission_int"
                            value={commission_int}
                            onChange={onInputChange}
                            required
                        />
                    </div> */}







                    <div className='container d-flex align-items-center justify-content-center mt-5'>
                        <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-secondary">Atrás</button>

                        <button type="button" onClick={handleSave} className="btn btn-primary ms-5" >Guardar</button>
                    </div>
                </form>
                <div style={{ height: '100px' }}></div>
            </div>
            {
                errorMessage.length > 0 ? <Message type='error' message={errorMessage} closeDialog={removeError} handleOk={removeError} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }
            {
                successMessage.length > 0 ? <Message type='success' message={successMessage} title='Exitoso' closeDialog={removeSucessMessage} handleOk={removeSucessMessage} backgroundColor='rgba(0,0,0,0.4)' /> : ''
            }



        </div>
    )
}


const styles = {
    container: {
        flex: 1,
        marginTop: 10,
        marginHorizontal: 20
    }
};
